// Slugs are saved as a single segment: the API strips "/" (so a "header/" prefix
// turned "header" into "headerheader") and the group is stored separately.
export const PAGE_GROUPS = [
  {
    label: "System",
    value: "system",
    defaultPrefix: "",
    defaultSuffix: "",
  },
  { label: "Page", value: "page", defaultPrefix: "", defaultSuffix: "" },
  {
    label: "Header",
    value: "header",
    defaultPrefix: "",
    defaultSuffix: "",
  },
  {
    label: "Footer",
    value: "footer",
    defaultPrefix: "",
    defaultSuffix: "",
  },
  {
    label: "Services",
    value: "services",
    defaultPrefix: "categories/",
    defaultSuffix: "",
  },
];

// Service pages: each product category has its own CMS page, slug
// "categories-<category slug>" in the "services" group, shown at
// /categories/<category slug> on the site (the API strips "/" from slugs, so
// the prefix can't be "categories/"). A category without one shows
// "categories/default" (created with Add in the Services tab), which is also
// the starting content when a category's page is first opened.
export const SERVICE_GROUP = "services";
export const SERVICE_DEFAULT_SLUG = "categories/default";
export const serviceCmsSlug = (categorySlug) => `categories/${categorySlug}`;

// Variables a service page can use in any text (section fields and SEO). The
// website replaces them with the data of the category being shown.
export const SERVICE_VARIABLES = [
  { key: "category_name", label: "Category name" },
  { key: "category_description", label: "Category details (rich text)" },
  { key: "category_heading", label: "Category heading (falls back to name)" },
  { key: "category_heading_description", label: "Category heading description" },
  { key: "category_slug", label: "Category slug" },
  { key: "category_meta_title", label: "Category SEO title" },
  { key: "category_meta_description", label: "Category SEO description" },
];

export const variableToken = (key) => `{{${key}}}`;

// The slug without its group's prefix, as typed in the slug field. Strips the
// prefix however it was saved ("categories-", "categories/", or "categories"
// glued on after the API dropped the "/"), and repeated copies of it, so
// saving never stacks the prefix.
export const stripSlugPrefix = (slug, group) => {
  const { prefix } = getSlugParts(group);
  let rest = String(slug || "");
  const stem = prefix.replace(/[-/]+$/, "");
  if (!stem) return rest;
  while (rest.startsWith(stem) && rest.length > stem.length) {
    rest = rest.slice(stem.length).replace(/^[-/]+/, "");
  }
  return rest;
};

export const CMS_LANGUAGES = [
  { code: "en", label: "English (EN)", isDefault: true, flag: "🇬🇧" },
  { code: "bn", label: "Bengali (BN)", isDefault: false, flag: "🇧🇩" },
];

export const getSlugParts = (group) => {
  const found = PAGE_GROUPS.find(
    (g) =>
      g.value === group ||
      g.label.toLowerCase() === (group || "").toLowerCase(),
  );
  if (found) {
    return { prefix: found.defaultPrefix, suffix: found.defaultSuffix };
  }
  switch (group) {
    case "header":
      return { prefix: "", suffix: "" };
    case "footer":
      return { prefix: "", suffix: "" };
    case "system":
      return { prefix: "", suffix: "" };
    default:
      return { prefix: "", suffix: "" };
  }
};

export const CMS_THEME = {
  primary: "#8b0000",
  primaryHover: "#6b0000",
  darkCharcoal: "#111827",
  activeBackground: "#fef2f2",
  activeBorder: "#fca5a5",
  activeText: "#111827",
  activeIconBg: "#8b0000",
  activeIconColor: "#ffffff",
  defaultBackground: "#ffffff",
  defaultBorder: "#e5e7eb",
  defaultText: "#374151",
  defaultIconBg: "#f3f4f6",
  defaultIconColor: "#111827",
  hoveredBackground: "#f9fafb",
  hoveredBorder: "#8b000040",
  borderRadius: "6px",
};
